// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cf-textarea{resize:none;width:calc(100% - 18px);margin:0}.cf-textarea:focus{outline:none}.cf-radio-btns>.flex-col{gap:0}", ""]);
// Exports
module.exports = exports;
